export default function ContractSCU({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
    return (
        <div className="container mb100 mt100">
                    <div className="beckertitlename mb100 mt100">Becker 學分班方案</div>
                    <div class="card w-75 p-5 m-auto">
                    <h5 class="card-title text-black text-center">Becker 學分班 方案購買須知與同意事項 (請務必詳閱)</h5>
                    <div className="br mb-5 mt-3"></div>
                    <div class="card-body">
                    <p class="card-text m-auto">
                        <div>
                            <ol>
                                <li>
                                報名學分班者，須填妥本報名表，完整審閱同意事項後，完成付費，方符合訂購程序。繳費前，請先確認購買產品內容與費用。
                                </li>
                                <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容，並同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
                                <li>
                                本學分班為 Becker Taiwan (捷進)美國註冊會計師系列之附加產品，報名者須符合以下資格，方可報名與參加學分班：
                                <ul>
                                    <li>報名學分班時，報名者本人已購買 Becker Taiwan (捷進)美國註冊會計師「專業方案」或「全修方案」 ，並尚在使用效期內。</li>
                                    <li>所報名之學分班學期結束日，不晚於個人 Becker 所購方案使用效期到期日。</li>
                                </ul>
                                </li>
                                <li>
                                本學分班課程使用 Becker CPA Exam Review 與 Becker CPA Final Review 教材內容，使用效期、準則、方式皆依照
                                <a href="./csu">「Becker CPA 方案線上報名表」</a>所列為準。
                                </li>
                                <li>
                                購買者所填報名學分班資料表 E-mail 信箱資訊，購買後請自行定期收信，本課程服務及一切相關資訊將以該 E-mail 信箱為主要聯繫方式，若因學員未定期收信導致權益受影響，學員應自負其責。
                                </li>
                                <li>
                                本學分班使用為美國 Becker Professional Education 進口原版教材授課，課程內容受美國聯邦政府智慧財產權法、與中華民國政府經濟部智慧財產權法保護，限購買者個人使用與參加，不得轉贈、轉讓及分享。
                                <ul>
                                    <li>
                                    為提升服務品質及確保學員正確使用本課程教材與影片，Becker Professional Education 與 Becker Taiwan (捷進)
                                    將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址 (IP address) 等相關資訊。
                                    在任何情況下，系統若發現有多人登錄同一帳號情況，Becker Taiwan (捷進)有權中止該帳號之課程使用權限。
                                    </li>
                                </ul>
                                </li>
                                <li>
                                學分班報名費用退費標準：
                                <ul>
                                    <li>因故未能開班上課，全額退還已繳之報名費用。</li>
                                    <li>
                                    學員完成報名繳費後，倘因個人因素無法上課時，依下列標準退還報名費用：
                                    <ul>
                                        <li>學員自報名繳費後至實際上課日前退費者，退還已繳報名費之九成。</li>
                                        <li>自實際上課日起未逾全期三分之一者，退還學費、雜費等各項費用之半數。</li>
                                        <li>若已逾所選課程全長三分之一者，不予退還。</li>
                                    </ul>
                                    </li>
                                </ul>
                                </li>
                                <li>
                                Becker Taiwan (捷進) 學分班產品說明與限制：
                                <ul>
                                    <li>
                                    學分班一門課為3學分，學員得於參加「專業方案」或「全修方案」所含 Becker Taiwan (捷進)中文課程(正課)後，完成學分班課程，課後測驗及格，方得申請學分成績。
                                    <ul>
                                        <li>
                                        正課屬「專業方案」或「全修方案」 內容，使用效期、準則、方式皆依照「Becker CPA 方案線上報名表」所列為準。
                                        </li>
                                    </ul>
                                    </li>
                                    <li>
                                    學分班開課日期與完課申請學分證明之截止日期，依 Becker Taiwan 於官網 (www.beckertw.com) 公告之課表為準。
                                    </li>
                                    <li>
                                    學分班測驗評量方式依加州州立大學東灣分校 (CSUEB) 規定，顯示於 Becker Taiwan 於官網 (www.beckertw.com)
                                    公告之各門課程大綱內。
                                    <ul>
                                        <li>課後測驗於線上考試系統進行。</li>
                                        <li>
                                        學分班產品不含線上考試報名費，單次測驗所需費用依線上考試系統公告為準，由學員於報名測驗時，直接向該系統單位付費。
                                        </li>
                                    </ul>
                                    </li>
                                    <li>學分班可能包含之面授、雲端課程、與協助參加課後測驗、申請註冊 CSUEB 學分成績等加值服務之提供，有效期限與學員個人軟體效期一致。</li>
                                    <li>
                                    學分班可能包含之面授、雲端課程，學員可以選擇以其一型式參加，參加後不得要求變更、轉讓以及重複行使權益。
                                    <ul>
                                        <li>
                                        學員單門課程選擇面授型式者，需於報名當下確認面授科目與學期為何，獲確認該科面授課程保留教室座位名額，需完整參加，於所選學期完成課程；
                                        </li>
                                        <li>
                                        使用面授課程者若有缺課情況，缺席課程以雲端看課方式進行補課，雲端看課時數與面授缺席時數相同，不得要求增加時數。
                                        </li>
                                        <li>
                                        Becker Taiwan (捷進)保有面授課程開課日期之決定權，依各期實際開課公告認定，學員不得異議。
                                        </li>
                                    </ul>
                                    </li>
                                    <li>學員使用效期結束時，若未使用完畢學分班各類型課程時數，剩餘時數等同失效，不得異議。</li>
                                    <li>面授、雲端課程中不得針對內容進行任何錄音、錄影等側錄行為。</li>
                                    <li>
                                    Becker Taiwan (捷進) 保有各項加值服務與面授教室座位分配之決定權，
                                    學員欲使用上課服務均須提前來電或來訊預約，以確認辦公室與數位教室服務狀態與起迄時間。
                                    </li>
                                </ul>
                                </li>
                                <li>Becker Taiwan (捷進) 針對於所選學期內完成課程與測驗之學員，協助向 CSUEB 申請註冊學分成績。</li>
                                <li>
                                Becker Taiwan (捷進)基於本訂購單履約之目的，蒐集、處理並利用您的個人資料，
                                未經您的同意， Becker Taiwan (捷進)不會將您的個人資料提供給第三人或作不當利用，
                                您享有個人資料保護法及相關法令之一切權利。
                                </li>
                                <li>購買者之報考資格應以考試指定之認證機構以及報名審查官方機構出具之審查結果為準。</li>
                                <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利，賣方亦保留任何因賣方代理原廠更改貨品規格而更改之權利並對此不負擔責任。</li>
                                <li>
                                捷進顧問有限公司 (Becker Taiwan) 已依照台北市短期補習班管理規則之規定立案登記
                                (許可證書編號：北市補習班證字第7620號)，
                                並已加入中華民國補教業品保協會辦理之補習服務聯合連帶保證協定
                                (品保協會會員編號：020267)。
                                </li>
                            </ol>
                            </div>

                    </p>
    
                    <div className="text-center">
                        <label>
                        <input className="m-2" type="checkbox" value="read" checked={isChecked} onChange={handleCheckboxChange} required />
                        <span>我已詳閱並且了解</span>
                        </label>
                        <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>下一步</div>
                    </div>
                    </div>
                </div>
                </div>
        );
    }